import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)


// Funcion para sumar valores
function sumar(elemState, nombre){
  var ingresos = elemState;
  var getValorUno = ingresos.map(elem => {
    return elem.valorUno != null ? elem.valorUno : 0;
  })
  var getValorDos = ingresos.map(elem => {
    return elem.valorDos != null ? elem.valorDos : 0;
  })
  var sumValorUno = getValorUno.reduce(function (total, num) {
    var suma = total != ""?total:0
    var numero = num != ""?num:0
    return parseInt(suma) + parseInt(numero);
  }, 0);
  var sumValorDos = getValorDos.reduce(function (total, num) {
    var suma = total != ""?total:0
    var numero = num != ""?num:0
    return parseInt(suma) + parseInt(numero);
  }, 0);
  sumar
  return [nombre, sumValorUno, sumValorDos, (sumValorUno - sumValorDos)]
}

function sumaPatrimonio(elemState){
  var patrimonio = elemState;
  var joinArray = [];
  var sumaValor = 0;

  var filterValores = patrimonio.map(elem => {
    return elem.valores.map(elemInt => {
      return elemInt.valor
    })
  }, this)

  var joinValor = joinArray.concat(filterValores[0],filterValores[1], filterValores[2])

  var filterValor = joinValor.filter(elem => {
    return elem != null;
  })

  if(filterValor.length > 0){
    sumaValor = filterValor.reduce((total, num) =>{
      var suma = total != ""?total:0
      var numero = num != ""?num:0
      return parseInt(suma) + parseInt(numero);
    })
  }

  return parseInt(sumaValor);
}


export const store = new Vuex.Store({
  state: {
    color: "light",
    nextPant: false,
    screens: [0, 0],
    video: null,
    tema: '',
    linksPath: '/admin-dinero/',
    cantPagsMods: {
      moduloUno: 0
    },

    // Ingresos por salario
    ingresoSalario: [
      {
        nombre: "Salario (después de descuentos de ley y otras deducciones)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Bonificaciones / Comisiones",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Auxilio de transporte",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Horas extras",
        valorUno: null,
        valorDos: null
      },
    ],
    // Otros ingresos
    otrosIngresoSalario: [
      {
        nombre: "Arriendo",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Otros negocios",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Ingresos por inversiones",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Trabajos varios",
        valorUno: null,
        valorDos: null
      },
    ],
    // Gastos Fijos
    gastosFijos: [
      {
        nombre: "Vivienda (arriendo o cuota hipotecaria)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Impuesto predial (anual, divídalo por 12)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Impuesto de vehículo (anual, divídalo por 12)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Seguro de salud",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Seguro de vida",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Crédito de vehículo",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Seguro de vehículo (anual, divídalo en 12)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Cuota de administración de vivienda",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Educación personal y familiar",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Mesada de los hijos",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Televisión por cable",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Internet",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Otro ¿cuál?",
        otro: '',
        valorUno: null,
        valorDos: null
      },
    ],
    // Gastos Variables
    gastosVariables: [
      {
        nombre: "Alimentación (mercado)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Reparaciones /mantenimiento del hogar",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Servicios personales / familiares (lavandería artículos de tocador, cortes de pelo).",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Elementos de aseo",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Pago de deudas (tarjetas de crédito / préstamos diferentes al hipotecario).",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Gastos médicos / odontológicos / medicinas",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Teléfono fijo ",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Agua / aseo",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Energía eléctrica",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Gas",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Transporte (gasolina, reparaciones, peajes, transporte público)",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Otro ¿cuál?",
        otro: '',
        valorUno: null,
        valorDos: null
      },
    ],
    // Gastos Opcionales
    gastosOpcionales: [
      {
        nombre: "Alimentación fuera de casa",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Ropa",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Regalos",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Descanso y diversión",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Celular",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Libros / revistas / periódicos",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Caridad",
        valorUno: null,
        valorDos: null
      },
      {
        nombre: "Otro ¿cuál?",
        otro: '',
        valorUno: null,
        valorDos: null
      },
    ],
    // Activos patrimonio
    patrimonioActivo: [
      {
        nombre: 'Propiedades',
        valores: [
          {
            desc: 'Vivienda propia (Valor del avalúo del inmueble)',
            valor: null
          },
          {
            desc: 'Vehículo personal (Valor comercial)',
            valor: null
          },
          {
            desc: 'Otras propiedades',
            valor: null
          },
        ]
      },
      {
        nombre: 'Inversiones',
        valores: [
          {
            desc: 'Finca raíz que genere renta (valor del avalúo del inmueble)',
            valor: null
          },
          {
            desc: 'CDT',
            valor: null
          },
          {
            desc: 'Otras propiedades',
            valor: null
          },
        ]
      },
      {
        nombre: 'Ahorro',
        valores: [
          {
            desc: 'En bancos',
            valor: null
          },
          {
            desc: 'En fondos de ahorro',
            valor: null
          },
          {
            desc: 'En fondos de empleados',
            valor: null
          },
          {
            desc: 'En fondos voluntarios de pensiones',
            valor: null
          },
          {
            desc: 'Dinero que le deban',
            valor: null
          },
          {
            desc: 'Otros ahorros',
            valor: null
          },
        ]
      },
    ],
    // Pasivos patrimonio
    patrimonioPasivo: [
      {
        nombre: 'Deudas',
        valores: [
          {
            desc: 'Cantidad total restante de su préstamo de vivienda',
            valor: null
          },
          {
            desc: 'Cantidad total restante de su préstamo de vehículo',
            valor: null
          },
          {
            desc: 'Cantidad total restante de sus préstamos bancarios',
            valor: null
          },
          {
            desc: 'Cantidad total restante de su préstamo estudiantil',
            valor: null
          },
          {
            desc: 'Saldos en sus tarjetas de crédito',
            valor: null
          },
          {
            desc: 'Impuestos por pagar',
            valor: null
          },
          {
            desc: 'Cualquier otra deuda',
            valor: null
          },
        ]
      }
    ]
  },
  getters: {

    // Ingresos por salario
    ingresoSalarioDiferencia: state => {
      var resultado = state.ingresoSalario.map(item => {
        return '$' + (item.valorUno - item.valorDos)
      })
      return resultado
    },
    ingresoSalarioTotal: state => {
      return sumar(state.ingresoSalario, '1. Subtotal ingreso por salario')
    },
    // Otros ingresos por salario
    OtrosIngresoSalarioDiferencia: state => {
      var resultado = state.otrosIngresoSalario.map(item => {
        return '$' + (item.valorUno - item.valorDos)
      })
      return resultado
    },
    OtrosIngresoSalarioTotal: state => {
      return sumar(state.otrosIngresoSalario, '2. Subtotal otros ingresos')
    },

    // Suma ingresos mas otros ingresos
    ingresosMasOtrosIngresos: (state, getters) => {
      var ingresos = getters.ingresoSalarioTotal;
      var otrosIngresos = getters.OtrosIngresoSalarioTotal;
      return ['3. Total de ingresos más otros ingresos', (ingresos[1] + otrosIngresos[1]), (ingresos[2] + otrosIngresos[2]), (ingresos[3] + otrosIngresos[3])]
    },

    // Gastos Fijos
    gastosFijosDiferencia: state => {
      var resultado = state.gastosFijos.map(item => {
        return '$' + (item.valorUno - item.valorDos)
      })
      return resultado
    },
    gastosFijosTotal: state => {
      return sumar(state.gastosFijos, '4. Subtotal gastos fijos')
    },

    // Gastos variables
    gastosVariablesDiferencia: state => {
      var resultado = state.gastosVariables.map(item => {
        return '$' + (item.valorUno - item.valorDos)
      })
      return resultado
    },
    gastosVariablesTotal: state => {
      return sumar(state.gastosVariables, '5. Subtotal gastos variables')
    },

    // Gastos opcionales
    gastosOpcionalesDiferencia: state => {
      var resultado = state.gastosOpcionales.map(item => {
        return '$' + (item.valorUno - item.valorDos)
      })
      return resultado
    },
    gastosOpcionalesTotal: state => {
      return sumar(state.gastosOpcionales, '6. Subtotal gastos opcionales')
    },
    // Suma ingresos mas otros ingresos
    totalGastos: (state, getters) => {
      var totalGastosFijos = getters.gastosFijosTotal;
      var totalGastosVariables = getters.gastosVariablesTotal;
      var totalGastosOpcionales = getters.gastosOpcionalesTotal;
      return ['7. Total gastos',
      (totalGastosFijos[1] + totalGastosVariables[1] + totalGastosOpcionales[1]),
      (totalGastosFijos[2] + totalGastosVariables[2] + totalGastosOpcionales[2]),
      (totalGastosFijos[3] + totalGastosVariables[3] + totalGastosOpcionales[3])]
    },
    // Flujo de caja mensual
    flujoDeCaja: (state, getters) => {
      var totalIngresos = getters.ingresosMasOtrosIngresos;
      var totalGastos = getters.totalGastos;
      return ['Flujo de caja mensual positivo o negativo',
      (totalIngresos[1] - totalGastos[1]),
      (totalIngresos[2] - totalGastos[2]),
      (totalIngresos[3] - totalGastos[3])]
    },
    // Total Activos patrimonio
    patrimonioTotalActivos: state => {
      return sumaPatrimonio(state.patrimonioActivo);
    },
    // Total Pasivos patrimonio
    patrimonioTotalPasivos: state => {
      return sumaPatrimonio(state.patrimonioPasivo);
    },
    // Diferencia patrimonio
    diferenciaPatrimonio: (state, getters) => {
      var activos = getters.patrimonioTotalActivos;
      var pasivos = getters.patrimonioTotalPasivos;
      return activos - pasivos
    },
  },
  mutations: {
    changeColor: state => state.color === "light" ? state.color = "dark" : state.color = "light",
    nextShow: (state, event) => state.nextPant = event,
    screenTrack: (state, [currentScr, cantScr]) => state.screens = [currentScr, cantScr],
    temaName: (state, event) => state.tema = event,
  }
});



// WEBPACK FOOTER //
// ./src/js/store/store.js